'use client'
import React from 'react'
import { Accordion, AccordionItem } from '@nextui-org/react'

const Accordian = () => {
    const faqDetails = [
        {
            title: 'What is Chaivio Vending ?',
            content: 'We provide vending service across America. Delivery, Installation and Vending Machine is provided with minimal cost to you. Our service is 100% reliable and cost effective.'
        },
        {
            title: 'Do You Offer Commission?',
            content: 'Yes! Commissions are available to qualified locations. We will work with you to determine commissions/percentage(s) based on sales.'
        },
        {
            title: 'How does the process work?',
            content: '1. Complete the form on this page and tell us a bit about your location. 2. We will reach out to you and discuss your vending needs and answer any questions you may have. We are here to help! 3. Machines can then typically be installed in a week or less. Delivery, installation and vending equipment is provided to your location.'
        },
        {
            title: 'Can we request a certain type or model of vending machine and who stocks the machine with product?',
            content: 'Absolutely! Just let us know what type of machine you are looking for (Tea flavors and Coffee varieties, etc) and we will find the best solution for you. We will keep the vending machines fully stocked with the selected flavor of tea/coffee.'
        },
        {
            title: 'Do we have to Pay For Machines?',
            content: 'Delivery, installation and vending equipment is provided at minimal cost for your location. Your vending provider will service, maintain and stock the machine regularly which is also free to you.'
        },

    ]
    return (
        <Accordion variant='bordered' className='w-[94%] max-w-[720px]'>
            {
                faqDetails.map((faq, index) => {
                    return (
                        <AccordionItem key={index} title={faq.title}>
                            <p>{faq.content}</p>
                        </AccordionItem>
                    )
                })
            }
        </Accordion>
    )
}

export default Accordian